import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { CodeField } from 'react-native-confirmation-code-field';
import Cell from './cell';
const CELL_WIDTH = 48;
const CELL_GAP = 8;
const Container = styled.View`
  width: ${_ref => {
  let {
    width
  } = _ref;
  return width;
}}px;
`;
export default function LoginPin(props) {
  const {
    secureTextEntry,
    error,
    value,
    onChangeText,
    cellCount
  } = props;
  const [incrementing, setIncrementing] = useState(true);
  const cellGaps = cellCount - 1;
  return /*#__PURE__*/React.createElement(Container, {
    width: cellGaps * CELL_GAP + cellCount * CELL_WIDTH
  }, /*#__PURE__*/React.createElement(CodeField, {
    value: value,
    cellCount: cellCount,
    onChangeText: newValue => {
      const decrementing = newValue.length < value.length;
      setIncrementing(!decrementing);
      onChangeText(newValue);
    },
    renderCell: _ref2 => {
      let {
        index,
        symbol,
        isFocused
      } = _ref2;
      return /*#__PURE__*/React.createElement(Cell, {
        key: index,
        index: index,
        symbol: symbol,
        cellFocused: isFocused,
        secureTextEntry: secureTextEntry,
        error: error,
        value: value,
        incrementing: incrementing,
        cellWidth: CELL_WIDTH
      });
    }
  }));
}
LoginPin.defaultProps = {
  secureTextEntry: false,
  error: false,
  value: '',
  onChangeText: () => null,
  cellCount: 4
};
LoginPin.propTypes = {
  secureTextEntry: PropTypes.bool,
  error: PropTypes.bool,
  value: PropTypes.string,
  onChangeText: PropTypes.func,
  cellCount: PropTypes.number
};
//# sourceMappingURL=index.js.map